import React, {useState, useContext, FC} from 'react';
import { connect } from "react-redux"
import {Grid, Button, Modal, Accordion} from 'semantic-ui-react';

import GlobalContext from '../../../contexts/GlobalContext';
import ModalConfirmCancelBooking from '../Modal/ModalConfirmCancelBooking';
import ModalRequestUpdateBooking from '../Modal/ModalRequestUpdateBooking';
import './BookingsCard.css';
import BookingCard from './BookingCard'
import { RootDispatch, RootState } from '../../../store';
import BookingAllDetails from './BookingAllDetails';

const mapProps = (state: RootState) => ({
  bookings: state.booking.bookings,
  bookingsByStatus: state.booking.bookingsByStatus,
  modal: state.modal
})

const mapDispatch = (dispatch: RootDispatch) => ({
  handleModal: dispatch.modal.handleModal
})

type Props = {
  clickConfirmCancelBookings: Function
} & ReturnType<typeof mapProps> & ReturnType<typeof mapDispatch>

const BookingsCardList: FC<Props> = ({
  bookings, bookingsByStatus, handleModal, modal
}) => {
  const [globalContext] = useContext(GlobalContext) as any;
  const [openModalAllSupplementState, setOpenModalAllSupplementState] = useState(false);
  const [isOpenCancelledBookingsAccordion, setIsOpenCancelledBookingsAccordion] = useState(false)

  const handleAccordionBookingsCancelledClick = () => {
    setIsOpenCancelledBookingsAccordion(!isOpenCancelledBookingsAccordion)
  }
  const close = () => { setOpenModalAllSupplementState(false) }

  return (
    <div>
      <Grid style={{ height: "100%" }} columns="equal" className="m-0">
        <Grid.Row>
          {bookingsByStatus['noCancelledBookings'].map((booking, index) => (
            <BookingCard key={index} booking={booking} bookingIndex={index} />
          ))}
        </Grid.Row>

        {
          bookingsByStatus['cancelledBookings'].length > 0 &&
          <Grid.Row>
            <Accordion fluid className="cancelledBookingsAccordion">
              {
                bookingsByStatus['noCancelledBookings'].length > 0 &&
                <Accordion.Title onClick={handleAccordionBookingsCancelledClick}>
                    <Button
                        color="red"
                        size="mini"
                        icon="arrows alternate vertical"
                        labelPosition="left"
                        content={
                          isOpenCancelledBookingsAccordion ? globalContext.translations.hideCancelledBookings : globalContext.translations.displayCancelledBookings +
                            " (" + bookingsByStatus['cancelledBookings'].length + ")"
                        }
                    >
                    </Button>
                </Accordion.Title>
              }


              <Accordion.Content active={isOpenCancelledBookingsAccordion}>
                {bookingsByStatus['cancelledBookings'].map((booking, index) => (
                  <BookingCard key={index} booking={booking} bookingIndex={index} />
                ))}
              </Accordion.Content>
            </Accordion>
          </Grid.Row>
        }

      </Grid>
      <Modal
        open={openModalAllSupplementState}
        closeOnDimmerClick={false}
        onClose={close}
      >
        <Modal.Header>
          {globalContext.translations.deleteBookingHeader} ?
        </Modal.Header>
        <Modal.Content>
          <p>{globalContext.translations.deleteBookingContent}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={close} negative>
            {globalContext.translations.cancel}
          </Button>
          <Button
            onClick={close}
            positive
            labelPosition="right"
            icon="checkmark"
            content={globalContext.translations.deleteBookingHeader}
          />
        </Modal.Actions>
      </Modal>
      <ModalConfirmCancelBooking />
      <ModalRequestUpdateBooking />
      <Modal
        open={modal.bookingDetailsModal}
        onClose={() => handleModal({ bookingDetailsModal: false })}
        closeIcon
      >
        <Modal.Header>{globalContext.translations.allTheDetails}</Modal.Header>
        <Modal.Content>
          <BookingAllDetails />
        </Modal.Content>
      </Modal>
    </div>
  );
}

export default connect(mapProps, mapDispatch)(BookingsCardList);
